import * as THREE from "three";
import {
  mergeMap,
  groupBy,
  filter,
  distinctUntilKeyChanged,
  switchMap,
  map,
} from "rxjs/operators";
import { of } from "rxjs";

export const AnimationToggleSystem = (world, props = {}) => {
  world.data.entity$
    .pipe(
      groupBy(
        (entity) => entity.id,
        (entity) => entity
      ),
      mergeMap((group$) =>
        group$.pipe(
          // filter
          filter(
            (entity) =>
              entity.animation?.rootObject &&
              entity.animation?.clip?.name &&
              entity.hasOwnProperty("animationToggle")
          ),

          distinctUntilKeyChanged("animationToggle"),

          // insert rootObject
          switchMap((entity) => {
            if (entity.animation.rootObject) {
              return world.object3DManager
                .getObject3D$(entity.animation.rootObject)
                .pipe(map((rootObject) => ({ entity, rootObject })));
            } else {
              return of({ entity });
            }
          }),

          filter((result) => result.rootObject),

          map((result) => {
            return {
              ...result,
              action: world.animationManager.getAnimationAction(
                result.rootObject,
                result.entity.animation
              ),
            };
          })
        )
      )
    )

    // .subscribe(({ definition, action }) => {
    .subscribe(({ entity: { animationToggle }, action }) => {
      if (animationToggle) {
        action.clampWhenFinished = true;
        action.timeScale = 1;
        action.setLoop(THREE.LoopOnce);
        if (!action.isRunning()) {
          // activate animation action
          // this is needed for reverse
          action.paused = false;
          action.play();
        }
      } else {
        action.clampWhenFinished = true;
        action.timeScale = -1;
        if (!action.isRunning() && action.paused) {
          // activate animation action
          // this is needed for reverse
          action.paused = false;
          action.play();
        }
      }
      world.change$.next();
    });
};

export default AnimationToggleSystem;
